import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import {
  getCatalogTypes,
  getCatalogDescendants,
  createCatalog,
  updateCatalog as updateCatalogApi,
  deleteCatalog,
} from "../../api/modules/catalogs/catalogs.api";
import type { CreateCatalogDto, UpdateCatalogDto } from "../../api/modules/catalogs/catalogs.types";

export const getCatalogs = createAsyncThunk(
  "catalogs/getCatalogs",
  async (_, { rejectWithValue }) => {
    try {
      return await getCatalogTypes();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDescendants = createAsyncThunk(
  "descendants/getDescendants",
  async (id: string, { rejectWithValue }) => {
    try {
      return await getCatalogDescendants(id);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addCatalog = createAsyncThunk(
  "catalog/addCatalog",
  async (catalog: CreateCatalogDto | FormData, { rejectWithValue }) => {
    try {
      const data = await createCatalog(catalog as CreateCatalogDto);
      toast.success("Catálogo creado", { autoClose: 3000 });
      return data;
    } catch (error: any) {
      toast.error(error?.message ?? "Ocurrió un error al crear el catálogo", { autoClose: 3000 });
      return rejectWithValue(error);
    }
  }
);

export const updateCatalog = createAsyncThunk(
  "catalog/updateCatalog",
  async ({ catalog, idCatalog }: { catalog: UpdateCatalogDto | FormData; idCatalog: string }, { rejectWithValue }) => {
    try {
      const data = await updateCatalogApi(idCatalog, catalog as UpdateCatalogDto);
      toast.success("El catálogo se actualizó correctamente", { autoClose: 3000 });
      return data;
    } catch (error: any) {
      toast.error(error?.message ?? "Ocurrió un error al actualizar el catálogo", { autoClose: 3000 });
      return rejectWithValue(error);
    }
  }
);

export const deletedCatalog = createAsyncThunk(
  "catalog/deletedCatalog",
  async (id: string, { rejectWithValue }) => {
    try {
      await deleteCatalog(id);
      toast.success("El catálogo se borró correctamente", { autoClose: 3000 });
      return { id };
    } catch (error: any) {
      toast.error(error?.message ?? "Ocurrió un error al borrar el catálogo", { autoClose: 3000 });
      return rejectWithValue(error);
    }
  }
);
